<template><svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path d="M7,2L3,6v8h10V2H7z M12,13H4V7h4V3h4V13z" />
</svg>
</template>